import { ROWS_PER_PAGE } from '@/constants/admin';

export const RESIDENT_DETAILS_TABS = {
  GENERAL: 'General',
  EDIT: 'Edit User',
  // PAYMENTS: 'Payments',
  // TRANSACTIONS: 'Transactions',
} as const;

export const DEFAULT_RESIDENT_FILTER_MODEL = {
  items: [
    { field: 'lease_status', operator: 'is', value: 'current' },
    { field: 'lease_status', operator: 'is', value: 'notice' },
  ],
};

export const DEFAULT_RESIDENT_SORT_MODEL = [{ field: 'name', sort: 'asc' }];

export const DEFAULT_PAGINATION_MODEL = {
  page: 0,
  pageSize: ROWS_PER_PAGE,
};


